import { createServerFn } from "@tanstack/react-start";
import z from "zod";
import {
  MAPS_CLIENT_EVENTS,
  mapsCallSourceSchema,
  releaseShaSchema,
} from "~/lib/maps/attribution";
import {
  recordMapsClientEvent,
  type MapsClientEventResult,
} from "~/lib/server-functions/maps-client-event";

/**
 * Input contract: a closed set of enums plus an optional short hex release, so a
 * client cannot write arbitrary text into the usage ledger.
 */
export const mapsClientEventSchema = z.object({
  event: z.enum(MAPS_CLIENT_EVENTS),
  source: mapsCallSourceSchema,
  /** Release that rendered the page; may lag the server after a deploy. */
  releaseSha: releaseShaSchema,
});

/**
 * Endpoint for browser Dynamic Maps telemetry.
 *
 * Only the handler body may touch server-only code: this module is reachable
 * from the client bundle, so the recording logic lives in `maps-client-event.ts`
 * and nothing that reaches the database is re-exported from here.
 */
export const logMapsClientEvent = createServerFn({ method: "POST" })
  .inputValidator(mapsClientEventSchema)
  .handler(async (ctx): Promise<MapsClientEventResult> => {
    return recordMapsClientEvent(ctx.data);
  });
